import React from "react";

export const EmptyState = ({ 
  icon: Icon, 
  title, 
  description, 
  gradient = "from-blue-600 to-indigo-600",
  className = "" 
}) => (
  <div className={`text-center py-12 ${className}`}>
    <div className={`inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br ${gradient} rounded-2xl mb-6 shadow-lg`}>
      <Icon className="w-10 h-10 text-white" />
    </div>
    <h3 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
      {title}
    </h3>
    <p className="text-lg text-slate-600">{description}</p>
  </div>
);